module.exports = __webpack_public_path__ + "static/nshn-logo-fr-ea3a79a465c86b0dd24e2a307bc646af.png";